import { useState, useEffect } from 'react';
import { infoService, AvailableSymbolsResponse } from '../services/infoService';

/**
 * Custom hook to fetch and provide the list of available trading symbols.
 * @returns An object containing the symbols array and loading/error states.
 */
export const useSymbols = () => {
  const [symbols, setSymbols] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchSymbols = async () => {
      console.log('useSymbols: Starting to fetch symbols for wizard...');
      try {
        setIsLoading(true);
        setError(null);
        const data = await infoService.getAvailableSymbols();
        console.log(`useSymbols: Successfully fetched ${data.length} symbols for wizard`);
        setSymbols(data);
      } catch (err) {
        console.error('Error in useSymbols hook:', err);
        setError(err instanceof Error ? err : new Error('Failed to fetch symbols'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchSymbols();
  }, []);

  return { symbols, isLoading, error };
}; 